import { licenseService } from '../services'
import Vue from 'vue'
import $axios from '@/axios-instance.js'

const state = {
  all: {
    filterInitialized: false,
    defaultFilter: {
      name: '',
      customerName: null,
      orderByColumn: 'customerName',
      orderByDescending: false,
      product: null,
      customerId: null,
      valid: null
    },
    currentPage: 1,
    loading: true,
    saving: false,
    items: [],
    filter: {},
    meta: {}
  }
}

const actions = {
  initialize ({ commit }, customerId) {
    console.log('initialize action')
    commit('initialize', customerId)
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  getAll ({ commit }) {
    return licenseService.getAll()
      .then(
        data => {
          return data.result
        }
      )
  },

  getListData ({ commit }) {
    console.log('getting list data')
    commit('getListDataRequest')
    // console.log(Object.assign({}, state.all.filter))
    return licenseService.getListData(state.all.filter, state.all.currentPage)
      .then(data => {
        commit('getListDataSuccess', data.result)
        // console.log(data.result)
        return data.result
      })
      .catch(error => {
        if ($axios.isCancel(error)) {
          console.info('Previous request cancelled')
        } else {
          console.error(error)
        }
      })
  },

  getById ({ commit }, id) {
    return licenseService.getById(id)
  },

  create ({ commit, dispatch }, license) {
    commit('startSave')
    return licenseService.create(license)
      .then(license => {
        commit('endSave')
        commit('createSuccess', license.result)
        dispatch('getListData')
        return license.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, license) {
    console.log('update')
    commit('startSave')
    return licenseService.update(license)
      .then(license => {
        console.log('update complete')
        commit('endSave')
        commit('updateSuccess', license.result)
        return license
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('startSave')
    commit('deleteRequest', id)

    licenseService.delete(id)
      .then(license => {
        commit('endSave')
        commit('deleteSuccess', id)
      })
      .catch(error => {
        commit('endSave')
        commit('deleteFailure', error)
        return Promise.reject(error)
      })
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
    console.log('reset filter complete')
  },

  initialize (state) {
    console.log('initialize mutation')

    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  getListDataRequest (state) {
    state.all.loading = true
  },

  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },

  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state) {
    Vue.prototype.$toast('Licens skapad', 'success')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa licens', 'error')
  },

  // Update
  updateSuccess (state, updatedItem) {
    state.all.items = state.all.items.map(item =>
      item.licenseId === updatedItem.licenseId ? updatedItem : item
    )

    Vue.prototype.$toast('Licens uppdaterad', 'success')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera licens', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    state.all.items = state.all.items.map(item =>
      item.licenseId === id
        ? { ...item, deleting: true }
        : item
    )
  },

  deleteSuccess (state, id) {
    state.all.items = state.all.items.filter(item => item.licenseId !== id)
  },

  deleteFailure (state, error) {
    Vue.prototype.$toast('Kunde inte ta bort licens', 'error')
  }
}

const getters = {
  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.page = null
    defaultFilter.page = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

export const licenses = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/license.module.js